module.exports = new Promise((resolve, reject) => {
          const envUrl = window._env_?.ADMIN_URL;
          const isDev = !envUrl || envUrl.startsWith('$');
          const remoteUrl = isDev ? 'http://localhost:3002' : envUrl;

          if (true && isDev) {
            console.error('[Module Federation] ADMIN_URL not configured for production');
            reject(new Error('Admin MFE is not configured'));
            return;
          }

          const script = document.createElement('script');
          script.src = remoteUrl + '/remoteEntry.js?v=' + Date.now();
          script.onload = () => {
            resolve(window.admin);
          };
          script.onerror = () => {
            console.error('[Module Federation] Failed to load admin remote from:', remoteUrl);
            reject(new Error('Failed to load Admin MFE'));
          };
          document.head.appendChild(script);
        });